import axios from "axios";
import { Modal, Message } from "view-design";
import router from "@/router";
import { getToken, removeToken, removeUserInfo } from "@/utils/auth";

const querystring = require("querystring");

// create an axios instance
// const service = axios.create({
//   baseURL: "", // url = base url + request url
//   // withCredentials: true, // send cookies when cross-domain requests
//   timeout: 5000 // request timeout
// });
// request interceptor
axios.interceptors.request.use(
  config => {
    var token = getToken();
    if (token) {
      config.headers["X-Access-Token"] = token;
    }
    return config;
  },
  error => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code !== 200 && res.code !== 0 && res.code !== 500) {
      // 500: Token expired;
      if (res.status === 500 && res.data.message == "Token失效，请重新登录") {
        // to re-login
        // Modal.confirm({
        //   title: "确认退出？",
        //   okText: "退出",
        //   cancelText: "取消",
        //   onOk: () => {
        //     removeToken();
        //     removeUserInfo();
        //     // router.replace("/home");
        //   },
        //   onCancel: () => {}
        // });
        
        setTimeout(()=>{
          removeToken();
          removeUserInfo();
          router.replace("/login");
        }, 800)
      }
      return Promise.reject(res.message || "Error");
    } else {
      return res;
    }
  },
  error => {
    console.log("err" + error); // for debug
    // Message.error(error.response.data.message);
    if(error.response.data.message=="Token失效，请重新登录"){
      setTimeout(()=>{
        removeToken();
        removeUserInfo();
        // router.replace("/login");
      }, 800)
    }
    if (error.toString().includes("Request failed with status code 500")) {
      // removeToken();
      // router.replace("/home");
    }
    return Promise.reject(error.message);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/api/axios.js